import { Reveal } from "./Reveal";

const ABOUT_IMG =
  "https://images.pexels.com/photos/5506215/pexels-photo-5506215.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const About = () => (
  <section id="about" className="py-24 md:py-32">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
      <Reveal className="lg:col-span-5 order-2 lg:order-1">
        <div className="overflow-hidden rounded-[2rem] aspect-[4/5]">
          <img src={ABOUT_IMG} alt="A moment of calm" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
        </div>
      </Reveal>

      <div className="lg:col-span-7 order-1 lg:order-2">
        <Reveal>
          <p className="text-xs tracking-[0.3em] uppercase text-clay mb-6">The philosophy</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif font-light text-4xl sm:text-5xl leading-[1.05] tracking-tight text-ink">
            We believe healing begins <span className="text-clay italic">in the heart of the body</span> — where
            sound meets breath.
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 text-base sm:text-lg text-muted leading-relaxed max-w-2xl">
            Sound Body Retreat is a sanctuary built on three pillars: the resonance of sound, the
            wisdom of movement, and the spaciousness of stillness. Every retreat is designed to
            quiet the noise of daily life and reconnect you with your most grounded self.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg">
            {[
              { n: "3", l: "Healing pillars" },
              { n: "12+", l: "Guided practices" },
              { n: "1", l: "You, renewed" },
            ].map((s) => (
              <div key={s.l}>
                <p className="font-serif text-4xl text-forest">{s.n}</p>
                <p className="text-sm text-muted mt-1">{s.l}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
